import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { Constants } from '../app.constants';
import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import {  ViewChild, ElementRef, Renderer2  } from '@angular/core';

@Component({
  selector: 'echexpayment-generate-checkout-url',
  templateUrl: './generate-checkout-url.component.html',
  styleUrls: ['./generate-checkout-url.component.css']
})
export class GenerateCheckoutUrlComponent implements OnInit {
	
	public generateSecureUrl : any = {};
	public secureUrlLink :string;
	public token :string;
	public id :string;
	public isPressed: boolean=false;
	public validationConfirm_account_number: boolean = false;
	isAmountValid: boolean = true;
	isTranscationValid: boolean = true;
	isUrlValid = true; // initialize the flag to true
	public showWarning: boolean = false;
	public showFeeWarning: boolean = false;
	busy:Subscription;
	public characterLimitReached : boolean = false;


	constructor(private router: Router, private toastr: ToastrService,private renderer: Renderer2, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService, private CONSTANTS: Constants) { 

		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;

		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;
		//this.generateSecureUrl.pay_to_the_order_of = userDetails.first_name + ' ' +  userDetails.last_name;
		this.generateSecureUrl.pay_to_the_order_of = userDetails.business_name ? userDetails.business_name : (userDetails.first_name + ' ' +  userDetails.last_name);

		this.secureUrlLink = CONSTANTS.secureUrlLink;

	}

	ngOnInit() {
	}

	ngAfterViewInit() {
		this.renderer.selectRootElement('#Focus_amount').focus();
	}
	  
	@ViewChild('submitButton') submitButton: ElementRef;
	moveNext(nextInput: HTMLInputElement, number: number) {
		if(number === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
		 nextInput && nextInput.focus();
		}
	 }

	//Max Length check in amount
	limitDecimalLength(inputElement: HTMLInputElement) {
		const regex = /^\d{0,9}(\.\d{0,2})?$/;
		const inputValue = inputElement.value;
		
		if (!regex.test(inputValue)) {
		  inputElement.value = inputValue.slice(0, -1);
		}
	}
	FeelimitDecimalLength(inputElement: HTMLInputElement) {
		const regex = /^\d{0,3}(\.\d{0,2})?$/;
		const inputValue = inputElement.value;
		
		if (!regex.test(inputValue)) {
		  inputElement.value = inputValue.slice(0, -1);
		}
	}

    //Number validate
	validateAmountInput(input: HTMLInputElement) { 
		const numberValue = Number(input.value);
		if(input.value != '') {
			if (numberValue < 1 || numberValue > 999999999) {
				this.isAmountValid = false;
			} else {
				this.isAmountValid = true;
			}
		} else {
			this.isAmountValid = true;
		}
	}
	validateTranscationInput(input: HTMLInputElement) {
		if(input.value != '') {
			const numberValue = Number(input.value);
			if (numberValue < 1 || numberValue > 100) {
				this.isTranscationValid = false;
			} else {
				this.isTranscationValid = true;
			}
		} else {
				this.isTranscationValid = true;
		}
	}

	validateUrl(input: HTMLInputElement) {
	    const url = input.value;
		//const urlRegex = /^https?:\/\/(www\.)?[a-z0-9]+\.com\/?$/i;
		const urlRegex = /^https?:\/\/(?:www\.)?[a-z0-9]+(?:\.[a-z]{2,})+\/?$/i;
		if (urlRegex.test(url)) {
			this.isUrlValid = true; // set the flag to true if the URL is valid
		} else {
			this.isUrlValid = false; // set the flag to false if the URL is invalid
		}
	}

	//setAmountValue
    setAmountValue(amount){
		if(amount) {
		  	this.generateSecureUrl.amount = parseFloat(amount).toFixed(2);
		}
	}

	setFeeValue(amount){
		if(amount) {
		  	this.generateSecureUrl.transcation_fee = parseFloat(amount).toFixed(2);
		}
	}

    DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
          this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          }
          event.preventDefault();
        } 
      }

	  FeesCheck(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
          this.showFeeWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,3}(\.\d{0,2})?$/;
        const maxValue = 100;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showFeeWarning = true;
            setTimeout(() => {
              this.showFeeWarning = false;
            }, 3000);
            event.preventDefault();
          }
          event.preventDefault();
        } 
      }
	// Generate bank auth url
	generateChequeUrl(data){
		if(data.valid && this.isAmountValid && this.isTranscationValid){
            let model: any = data.value;
			model.id = this.id;
			model.user_token = this.token;
			model.token = this.id;
			model.cheque_link_type = 'secure_checkout_link';
			let responseData = <any>{};
			this.busy = this.echexpaymentService.generateChequeUrlApi(model).subscribe(
			response => {
					responseData = response;
					this.generateSecureUrl.secure_url_link = this.secureUrlLink+responseData.data.user_id+'/'+responseData.data.token;
			},
			error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			}
			);
		} else if(!this.isAmountValid){
			this.renderer.selectRootElement('#Focus_amount').focus();
		} else if(!this.isTranscationValid){
			this.renderer.selectRootElement('#transcation_fee').focus();
		}
  	}
	// Copy Text
  	copyText(){
		if(this.generateSecureUrl.secure_url_link){
			this.isPressed = true;
		}
        
    }
  
	checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
		  this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		  setTimeout(() => {
			this.characterLimitReached = false; // Hide the warning message after 3 seconds
		  }, 3000);
		  event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	}


}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/generate-checkout-url/generate-checkout-url.component.ts